/*eslint  @typescript-eslint/no-use-before-define: 0*/

import { defineModule } from "direct-vuex";
import { moduleActionContext, moduleGetterContext } from "@/store";
import { editOrderCommentData, getOrderCommentData } from "@/requests/order/order";
import { OrderCommentData } from "@/models/api/orders/OrderCommentData";
import { CHANGE_REASON } from "@/static/changeReasonEnum";

export interface OrderCommentStateInterface {
  orderId: null | string;
  orderComment: null | OrderCommentData;

  initialInternalChangeReasonId: null | CHANGE_REASON;
}

export const OrderCommentState: OrderCommentStateInterface = {
  orderId: null,
  orderComment: null,
  initialInternalChangeReasonId: null,
};

const OrderCommentModule = defineModule({
  state: OrderCommentState as OrderCommentStateInterface,
  namespaced: true as const,
  getters: {},
  mutations: {
    setOrderId(state, param: string | null) {
      state.orderId = param;
    },
    setOrderCommentData(state, param: OrderCommentData | null) {
      state.orderComment = param;
      state.initialInternalChangeReasonId = param?.internalChangeReasonId ?? null;
    },
  },
  actions: {
    async openOrderComment(context, orderId: string): Promise<void> {
      const { commit } = _moduleActionContext(context);
      commit.setOrderCommentData(null);
      commit.setOrderId(orderId);
      const response = await getOrderCommentData(orderId);
      commit.setOrderCommentData(response);
    },
    async saveOrderComment(context): Promise<void> {
      const { state, commit, rootDispatch } = _moduleActionContext(context);
      await rootDispatch.failIfRequestsInProgress();
      if (state.orderComment && state.orderId)
        await editOrderCommentData(state.orderId, {
          comment: state.orderComment.comment,
          internalChangeReasonId: state.orderComment.internalChangeReasonId,
          changeReasonDescription: state.orderComment.changeReasonDescription,
          formOfPaymentId: state.orderComment.formOfPaymentId,
          bankAccountId: state.orderComment.bankAccountId,
        });
      commit.setOrderId(null);
      commit.setOrderCommentData(null);
      rootDispatch.orders.getOrdersTable();
      rootDispatch.popup.addSavedOkSnackbar();
    },
  },
});

export default OrderCommentModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleGetterContext = (args: [any, any, any, any]) =>
  moduleGetterContext(args, OrderCommentModule);
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, OrderCommentModule);
